import { render } from "./battery.vue?vue&type=template&id=33c06d94&scoped=true"
import script from "./battery.vue?vue&type=script&lang=js"
export * from "./battery.vue?vue&type=script&lang=js"

import "./battery.vue?vue&type=style&index=0&id=33c06d94&lang=scss&scoped=true"
import "./battery.vue?vue&type=style&index=1&id=33c06d94&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c06d94"]])

export default __exports__